<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 会员列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<el-input placeholder="会员名称" clearable class="handle-input mr10" v-model="personName"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<!-- <el-button type="primary" icon="el-icon-search" @click="createMember">创建会员</el-button> -->
				<el-button type="primary" icon="el-icon-top" @click='updataMemberBtn'
					v-if="RoleId=='2d7a48e5-503b-463e-878a-361e1b175551'?false:true">升级为经销商</el-button>
			</div>
			<el-table :data="personList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				@select="updataMember" style="width: 100%">
				<!-- <el-table-column prop="Id" label="ID" align="center" width="300"></el-table-column> -->
				<el-table-column type="selection" width="55"
					v-if="RoleId=='2d7a48e5-503b-463e-878a-361e1b175551'?false:true">
				</el-table-column>
				<el-table-column prop="Name" label="姓名" align="center" min-width="150"></el-table-column>
				<el-table-column prop="NickName" label="昵称" align="center"></el-table-column>
				<!-- <el-table-column prop="RoleName" label="角色名称" align="center" min-width="100"></el-table-column> -->
				<!-- <el-table-column prop="Sex" label="Sex" align="center"></el-table-column> -->
				<!-- <el-table-column prop="Age" label="Age" align="center"></el-table-column> -->
				<el-table-column prop="Phone" label="手机号" align="center" min-width='150'></el-table-column>
				<!-- <el-table-column prop="IdentityCard" label="身份证号" align="center" min-width="200"></el-table-column> -->
				<!-- <el-table-column prop="Region" label="省份" align="center"></el-table-column> -->
				<el-table-column prop="Region" label="地区" align="center" min-width='200'></el-table-column>
				<el-table-column prop="Address" label="收货地址" align="center" min-width='200'></el-table-column>
				<!-- <el-table-column label="头像(点击查看大图)" align="center">
					<template #default="scope">
						<el-image class="table-td-thumb" :src="scope.row.HeadPhoto"
							:preview-src-list="[scope.row.HeadPhoto]">
						</el-image>
					</template>
				</el-table-column> -->
				<el-table-column prop="StateName" label="创建类型" align="center" min-width='100'></el-table-column>
				<el-table-column prop="createName" label="创建人" align="center" min-width='150'></el-table-column>
				<el-table-column prop="AddTime" label="添加时间" align="center" min-width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
						<!-- <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
						</el-button> -->
						<el-button type="text" icon="el-icon-setting" @click="handleReset(scope.$index, scope.row)">重置
						</el-button>
						<el-button type="text" icon="el-icon-delete" @click="deleteMember(scope.row)"
							style="color: #ff0000;">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>


			<el-dialog :title="title" v-model="isdelete" width="30%">
				<span>是否重置密码？</span>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="isdelete = false">取 消</el-button>
						<el-button type="primary" @click="deleteNews">确 定</el-button>
					</span>
				</template>
			</el-dialog>


			<!-- 编辑弹出框 查看弹出框-->
			<el-dialog :title="title" v-model="editVisible" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="姓名" prop="Name">
						<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="Phone">
						<el-input v-model="ruleForm.Phone" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="地区">
						<el-input v-model="ruleForm.Region" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="收货地址">
						<el-input v-model="ruleForm.Address" :disabled="isdisabled"></el-input>
					</el-form-item>
					<!-- 		<el-form-item label="密码" prop="PassWord">
						<el-input v-model="ruleForm.PassWord" show-password></el-input>
					</el-form-item> -->
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="editVisible = false">取 消</el-button>
						<el-button type="primary" @click="saveEdit('ruleForm')">确 定</el-button>
					</span>
				</template>
			</el-dialog>

		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				isdelete: false,
				title: '',
				personList: [],
				ruleForm: [],
				personName: '', //角色名称
				token: localStorage.getItem('access_token'),
				Id: localStorage.getItem('Id'),
				RoleId: localStorage.getItem('RoleId'),
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				name: '',
				editVisible: false,
				rules: {
					PassWord: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					Name: [{
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					}],
					Sex: [{
						required: true,
						message: '请输入性别',
						trigger: 'blur'
					}],
					Age: [{
						required: true,
						message: '请输入年龄',
						trigger: 'blur'
					}],
					Address: [{
						required: true,
						message: '请输入收货地址',
						trigger: 'blur'
					}],
					IdentityCard: [{
						required: true,
						message: '请输入身份证号',
						trigger: 'blur'
					}, {
						pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
						message: "目前只支持中国大陆的身份证号",
						trigger: "blur"
					}, {
						required: true,
						validator: this.bargainIdcard,
						trigger: "blur"
					}],
					Phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						pattern: /^1[0123456789]\d{9}$/,
						message: '目前只支持中国大陆的手机号码',
						trigger: "blur"
					}, {
						required: true,
						validator: this.bargainPhone,
						trigger: "blur"
					}],
				},
				isdisabled: false,
				updataMemberList: [],
				resetPass: '',
				sex: [{
						Id: 1,
						value: '男'
					},
					{
						Id: 2,
						value: '女'
					}
				]
			}
		},
		created() {
			this.getData()
		},
		methods: {
			deleteMember(row) {
				console.log(row)
				this.$confirm('此操作将删除会员, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					axios({
						method: 'post',
						url: this.$store.state.pcurl + "DeleteUser?userId=" + row.Id,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Data) {
							this.$message({
								type: 'success',
								message: '会员删除成功!'
							});
							this.getData()
						} else {
							this.$message.error('有关联数据,删除失败!')
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//重置密码
			handleReset(index, row) {
				console.log(row)
				this.title = '重置密码'
				this.isdelete = true
				this.resetPass = row.Id
			},
			deleteNews() {
				axios({
					method: 'post',
					url: this.$store.state.pcurl + "ResetPassword?userId=" + this.resetPass,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.editVisible = false
						this.$message({
							message: '重置密码成功',
							type: 'success'
						})
						this.getData()
						this.isdelete = false
					} else {
						this.$message.error('重置密码失败');
					}
				})
			},
			//会员转经销商
			updataMember(selection, row) {
				console.log(selection)
				this.updataMemberList = selection
			},

			updataMemberBtn() {
				var token = this.token;
				this.updataMemberList.forEach((x) => {
					x.RoleId = 'a591fe1e-7da8-4124-8912-b5af5282d57a'
					axios({
						method: 'POST',
						url: this.$store.state.pcurl + "UpdateUser",
						headers: {
							"Authorization": "bearer " + token + ""
						},
						data: x
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.$message({
								message: '修改成功',
								type: 'success'
							})
							this.getData()
						} else {
							this.$message.error('修改失败');
						}
					})
				})
			},
			//验证手机号
			bargainPhone(rule, value, callback) {
				if (this.title == '创建会员') {
					var token = this.token;
					axios({
						method: 'POST',
						url: this.$store.state.url + "CheckPhone?Phone=" + value,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该手机号已被添加"))
							}
						} else {
							callback(new Error("获取手机号信息失败"))
						}
					})
				} else if (this.title == '编辑') {
					var token = this.token;
					axios({
						method: 'post',
						url: this.$store.state.url + "CheckPhone?Phone=" + value + '&userId=' + this.ruleForm.Id,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该手机号已被添加"))
							}
						} else {
							callback(new Error("获取手机号信息失败"))
						}
					})
				} else {
					callback()
				}
			},
			//验证身份证号
			bargainIdcard(rule, value, callback) {
				if (this.title == '创建会员') {
					var token = this.token;
					axios({
						method: 'POST',
						url: this.$store.state.url + "CheckIdentityCard?IdentityCard=" + value,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						console.log(res)
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该身份证号已被添加"))
							}
						} else {
							callback(new Error("获取身份证信息失败"))
						}
					})
				} else if (this.title == '编辑') {
					var token = this.token;
					axios({
						method: 'post',
						url: this.$store.state.url + "CheckIdentityCard?IdentityCard=" + value + '&userId=' + this
							.ruleForm
							.Id,
						headers: {
							"Authorization": "bearer " + token + ""
						},
					}).then((res) => {
						if (res.status == 200) {
							if (res.data.Data) {
								callback()
							} else {
								callback(new Error("该身份证号已被添加"))
							}
						} else {
							callback(new Error("获取身份证信息失败"))
						}
					})
				} else {
					callback()
				}
			},
			getData() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUsers?roleid=be4e45c7-03cc-45ee-8f00-49c3665819ca" +
						'&pageSize=' + this.pageSize + '&pageIndex=' + pageIndex + '&name=' + this
						.name,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					this.pageTotal = res.data.Count
					if (res.data.Message == '请求成功') {
						this.personList = res.data.Data
						this.personList.forEach((x) => {
							x.AddTime = x.AddTime.replace('T', ' ')
							switch (x.UserType) {
								case 1:
									x.StateName = '会员自建';
									break;
								case 2:
									x.StateName = '客服创建';
									break;
								case 3:
									x.StateName = '经销商创建';
									break;
								case 4:
									x.StateName = '总评创建';
									break;
							}

							axios({
								method: 'get',
								url: this.$store.state.pcurl + "GetUserModel?userId=" + x
									.CreateUserId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								x.createName = res.data.Data.Name
							})

						})
					} else {
						this.$message.error('角色列表获取失败')
					}
				})
			},

			handleSearch() {
				this.name = this.personName
				this.pageIndex = 1
				this.getData()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getData()
			},
			//创建会员
			createMember() {
				this.isdisabled = false
				this.ruleForm = []
				this.editVisible = true
				this.title = '创建会员'
			},
			//查看
			handleClick(row) {
				console.log(row)
				this.title = '查看'
				this.isdisabled = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUserModel?userId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			// 编辑
			handleEdit(index, row) {
				this.title = '编辑'
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUserModel?userId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateUser",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title == '创建会员') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {

							switch (this.RoleId) {
								case 'be4e45c7-03cc-45ee-8f00-49c3665819ca':
									this.ruleForm.UserType = 1;
									break;
								case '2d7a48e5-503b-463e-878a-361e1b175551':
									this.ruleForm.UserType = 2;
									break;
								case 'a591fe1e-7da8-4124-8912-b5af5282d57a':
									this.ruleForm.UserType = 3;
									break;
								case '002860b9-6844-4982-9ac4-5453c9cdea3c':
									this.ruleForm.UserType = 4;
									break;
								case '5d59a2fe-5f94-4671-8394-e2fefdb6d2ed':
									this.ruleForm.UserType = 5;
									break;
							}
							this.ruleForm.CreateUserId = this.Id
							this.ruleForm.RoleId = 'be4e45c7-03cc-45ee-8f00-49c3665819ca'
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "AddUser",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '创建成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.editVisible = false
				}
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>
